import React from 'react';
import { Button } from 'antd';
import PropTypes from 'prop-types';
import { DeleteOutlined } from '@ant-design/icons';
import './styles.less';

const DeleteButton = ({ children, ...buttonProps }) => (
  <Button {...buttonProps} type="dashed" ghost className="delete-button--black">
    <DeleteOutlined /> {children}
  </Button>
);

DeleteButton.propTypes = {
  children: PropTypes.node,
};

DeleteButton.defaultProps = {
  children: <></>,
};

export default DeleteButton;
